export default "__VITE_ASSET__CD9o$C$___"